<template>
  <div id="app">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
// import axios from 'axios'
export default {
  name: 'App',
  data() {
    return {
      cachedViews: [], // 存储需要缓存的组件名
      // 缓存页面
      includes: [
        'calorie-query-index',
        'fatcamp-home',
        'fatcamp-second-class',
        'drink-water-reminder-index',
        'drink-water-reminder-set',
        'nutritionist-tool-diet-list',
        'common-questions-home',
        'betterwe-vip',
        'calorie-query-class-list',
        'calorie-query-search',
        'cna-question-v2-result',
        'cna-question-v2-recipe',
        'eating-today-home',
        'newoutline',
        'dounyin-integral-exchange-index',
        'dounyin-integral-exchange-login',
        'dounyin-integral-exchange-exchange',
        'dounyin-integral-exchange-record',
        'nutritionist-tool-camp-list',
        'app-course-course-list',
        'user-sign-index',
        'join-camp-question',
        'nutrition-clock-plan-list',
        'MainPage'
      ],
      //  配置不用默认请求user home的页面
      routerArray: [
        'BMICount',
        'die-selection',
        'camp-archives',
        'recipe-list',
        'stage-question'
      ]
    }
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      console.log('to', to)
      // 过滤出需要缓存的组件，即 meta.keepAlive = true 的组件
      const keepAliveComponent = to.matched.filter((record) => {
        return record.meta && record.meta.keepAlive
      })
      if (keepAliveComponent.length) {
        // 把需要缓存的组件的name放到cachedViews集合里
        keepAliveComponent.map((item) => {
          if (!this.cachedViews.includes(item.name)) {
            this.cachedViews.push(item.name)
          }
        })
      } else {
        const index = this.cachedViews.indexOf(to.name)
        if (index > -1) {
          this.cachedViews.splice(index, 1)
        }
      }
      if (to.query.token && !this.$betterwe.isApp()) {
        let token = this.$route.query.token.toString()
        if (token && token != 'undefined' && token != 'null') {
          localStorage.setItem('token', token)
          sessionStorage.setItem('token', token)
          // 存健萌token  进入健萌页面链接携带token为健萌token要存起来后面健萌请求取缓存的jmToken  不然从缓存取token会被updateToken刷成减脂营token
          this.$http._setCookie('jmToken', token)
        }
      }
      // token在链接里 如有则存入sessionStorage
      if (to.query.storageToken) {
        sessionStorage.setItem('storageToken', to.query.storageToken.toString())
        localStorage.setItem('storageToken', to.query.storageToken.toString())
      }
      // 需要获取地理位置的则获取地理位置
      if (to.meta && to.meta.location && !this.$store.state.user.user) {
        // 获取健萌排课信息、用户信息
        this.$http.init()
      }
      //如果是第一个页面则保存第一个页面的路径
      if (from.fullPath == '/') {
        sessionStorage.setItem('firstUrl', to.fullPath)
      }
    }
  },
  created() {
    this.init()
    // this.checkVersion()
    // detail里面数据依赖于subscribe页面并存在vuex，刷新页面vuex数据会丢失，所以要跳转回subscribe页面
    if (location.pathname.indexOf('/subscribe/detail') > -1)
      location.pathname = '/subscribe'
  },
  beforeCreate() {
    ;(function (w, d, s, q, i) {
      w[q] = w[q] || []
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s)
      j['async'] = true
      j['id'] = 'beacon-aplus'
      j['src'] = 'https://d.alicdn.com/alilog/mlog/aplus/' + i + '.js'
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'aplus_queue', '203467608')
    // 集成应用的appKey
    const appkey = '6264c99bd024421570cc1a3e'
    window['aplus_queue'].push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', appkey]
    })
    window['aplus_queue'].push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-waiting', 'MAN']
    })
    // 是否开启调试模式
    window['aplus_queue'].push({
      action: 'aplus.setMetaInfo',
      arguments: ['DEBUG', !window['online']]
    })
  },
  mounted() {
    this.$betterwe.getEnv()
  },
  methods: {
    init() {
      if (this.$betterwe.isApp()) {
        // 链接中无token 先取cookie中 (跳到健萌项目再从健萌项目直接返回链接上是无token的,同主域名可取到cookie里的token)
        let token =
          this.$http._getQuery('token') || this.$http._getCookie('token')
        if (token && token != 'undefined' && token != 'null') {
          localStorage.setItem('token', token)
          sessionStorage.setItem('token', token)
          // 存健萌token  进入健萌页面链接携带token为健萌token要存起来后面健萌请求取缓存的jmToken  不然从缓存取token会被updateToken刷成减脂营token
          this.$http._setCookie('jmToken', token)
        }
        this.$betterwe.updateToken().then(() => {
          this.$http.getUserData()
        })
      } else {
        this.$http.getUserData()
      }
    },
    /**
     * 检查版本号  手动刷新 每次上线需要马上在用户显示时手动修改version.json版本号
     */
    checkVersion() {
      axios
        .get(location.origin + `/version.json`, {
          headers: { 'Cache-Control': 'no-cache' }
        }) // 请求到json文件的内容, 并且禁止缓存
        .then((res) => {
          const version = res.data.version
          const clientVersion = localStorage.getItem('_version_')
          console.log('最新版本>>', version)
          console.log('当前版本>>', clientVersion)
          // 和最新版本不同，刷新页面
          if (clientVersion && version !== clientVersion) {
            localStorage.setItem('_version_', version)
            window.location.reload()
          }
        })
    }
  }
}
</script>

<style lang="scss">
@function vw($px) {
  @return ($px / 375) * 100vw;
}

// 解决rem布局 字体被放大问题 （也可以在font-size 最后加 /*px*/）
// 在一些情况下 textarea 标签内的字体大小即便加上上面的方案，字体也会变大，无法控制。此时你需要给 textarea 的 display 设为 table 或者 inline-table 即可恢复正常
// *,
// *:before,
// *:after {
//   max-height: 100000px;
// }
p {
  margin: 0;
  padding: 0;
}

body {
  padding: 0;
  margin: 0;
  color: #000;
  font-size: vw(14) !important;
  // IOS底部兼容  先constant再env
  // height: calc(96rpx+ constant(safe-area-inset-bottom)); //兼容 IOS<11.2
  // height: calc(96rpx + env(safe-area-inset-bottom)); //兼容 IOS>11.2
  // padding-bottom: constant(safe-area-inset-bottom); //兼容 IOS<11.2
  // padding-bottom: env(safe-area-inset-bottom); //兼容 IOS>11.2
}

body::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  width: 0;
  height: 0;
}

div {
  scrollbar-width: none;
  /* firefox */
  // -ms-overflow-style: none; /* IE 10+ */
}
:not(.show-scroll-bar)::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
  width: 0 !important;
}

a {
  text-decoration: none;
}

img {
  display: block;
  border: none;
}

// 空图片有边框 处理
img[src=''],
img:not([src]) {
  opacity: 0;
}

//   ‌-apple-system‌：这是为苹果系统设计的，包括了San Francisco字体。
// ‌BlinkMacSystemFont‌：这是Chrome和Edge在MacOS上的默认字体。
// ‌"Segoe UI"‌：这是Windows系统的默认字体。
// ‌Roboto‌：这是一个开源的、谷歌推荐的字体，适用于多种操作系统。
// ‌"Helvetica Neue"‌：这是iOS和MacOS上的默认字体。
// ‌Arial‌：这是一个广泛支持的无衬线字体。
// ‌sans-serif‌：如果上述字体都不可用，浏览器将回退到系统的默认无衬线字体。
#app {
  // font-family: PingFangSC, PingFang SC, PingFang-SC-Regular, Avenir, Helvetica,
  //   Arial, sans-serif;
  font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //font-family: PF, Avenir, Helvetica, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.8);
  // user-select: none;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
